export const featureFlags = [
  'withViewsPhase1',
  'withViewsPhase2',

  'withAdminPanel',

  'withScatterPlotWidget',
  'withReports',

  'withXAxisMetric',
  'withRunGroupsV3',

  // This flag controls only initial state for object-table suggestions
  'suggestionsEnabled',

  'withV4PricingInNewWorkspaces',
  'withAutoSavedDashboards',
  'withUnificationV1',
  'withEmbedInNotionFeature',
] as const;

export type FeatureFlag = (typeof featureFlags)[number];

export type FeatureFlagConfig = `${FeatureFlag}Config`;
